export default "__VITE_ASSET__1416960a__"